import { useNavigate } from 'react-router-dom';
import { apiUrl } from '../../config';
import { useEffect, useState } from 'react';
import useAuthRedirect from '../../utils/modules/useAuthRedirect'
import { useLanguage } from '../../LanguageContext';
import axios from 'axios';

const ClientRegisterComponent = () => {  
  const navigate = useNavigate();
  const [video, setVideo] = useState(null); // Видео
  const [isRegister, setIsLogin] = useState(true); // Состояние для переключения между логином и регистрацией
  const [loginData, setLoginData] = useState({
    'email': '',
    'phone': '',
    'password': '',
    'code': '',
    'confirm_password': ''
  });
  const [message, setMessage] = useState('');
  const [codeEnter, setCodeEnter] = useState(false);
  const [resetMode, setResetMode] = useState(false);
  const [resetCodeEnter, setResetCodeEnter] = useState(false);

  // Проверка авторизации при загрузке компонента
  useAuthRedirect('client', '/', '/authorization');

  const handleToggle = () => {
    setIsLogin(!isRegister); // Переключение между логином и регистрацией
    setMessage('');
  };
  const { language } = useLanguage();
  // #todo
  // const errors_messages = {
  //   '0': {
  //     'Üstünlikli girdiňiz. Siziň poçtaňyza hasaba giriş şahsy maglumatly hat goýberildi.',
  //     ''
  //   },
  //   '7': 'Nädogry poçta formaty.',
  // }

  const validInputsReq = (error_id) => {
    switch (error_id) {
      case 0:
        setCodeEnter(true);
        if (language === 'tm') {
          alert('Üstünlikli girdiňiz. Siziň poçtaňyza hasaba giriş şahsy maglumatly hat goýberildi.')
        }
        if (language === 'ru') {
          alert(`Вам на почту ${loginData.email} отправлено письмо c кодом для подтверждения.`)
        }
        break;
      case 7:
        if (language === 'tm') {
          setMessage('Nädogry poçta formaty.')
        }
        if (language === 'ru') {
          setMessage('Не верный формат почты.')
        }
        break;
      case 8:
        if (language === 'tm') {
          setMessage('Nädogry nomer formaty.')
        }
        if (language === 'ru') {
          setMessage('Номер телефона обязателен.')
        }
        break;
      case 9:
        if (language === 'tm') {
          setMessage('Nädogry nomer formaty.')
        }
        if (language === 'ru') {
          setMessage('Не верный формат номера телефона.')
        }
        break;
      case 4:
        if (language === 'tm') {
          setMessage('Gizlin sözüňiz azyndan 5 harp ya-da sandan (1@!.) ybarat bolmaly.')
        }
        if (language === 'ru') {
          setMessage('Пароль должен иметь как минимум 5 символов')
        }
        break;
      case 5:
        if (language === 'tm') {
          setMessage('Gizlin sözüňiz deň gelenok.')
        }
        if (language === 'ru') {
          setMessage('Пароли не совпадают')
        }
        break;
      case 10:
        if (language === 'tm') {
          setMessage('Bu elektron poçta eýýäm hasaba alnan. Giriň ýa-da paroly dikeldiň.')
        } else if (language === 'ru') {
          setMessage('Этот адрес уже зарегистрирован. Войдите или восстановите пароль.')
        } else {
          setMessage('This email is already registered. Sign in or reset your password.')
        }
        break;
    }
  }

  const client_register = async () => {
    if (language === 'tm') {
      setMessage('Garaşyň...');
    } else if (language === 'ru') {
      setMessage('Пожалуйста подождите...');
    }
    try {
      const response = await fetch(`${apiUrl}/api/client-register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(loginData),
      });
  
      const result = await response.json();
      validInputsReq(result.request.status);
      // client_login()

    } catch (error) {
      console.error('Ошибка при обработке запроса:', error);
      setMessage('Ошибка при обработке запроса.');
    }
  };

  const validInputsReqLogin = (error_id, token, asd) => {
    switch (error_id) {
      case 0:
        if (language === 'tm') {
          alert('Hasaba üstünlikli girdiňiz.')
        }
        if (language === 'ru') {
          alert('Успешный вход.')
        }
        localStorage.setItem('accessToken', token);
        localStorage.setItem('asd', asd);
        navigate('/');
        break;
      case 1:
        if (language === 'tm') {
          setMessage('Hasaba giriş şahsy maglumatyňyz ýalňyş.')
        }
        if (language === 'ru') {
          setMessage('Не верные учетные данные')
        }
        break;
      case 6:
        if (language === 'tm') {
          setMessage('Bu elektron poçta eýýäm tassyklanan.')
        } else if (language === 'ru') {
          setMessage('Этот адрес уже подтверждён. Войдите или восстановите пароль.')
        } else {
          setMessage('This email is already confirmed. Sign in or reset your password.')
        }
        break;
    }
  }

  const confirm_email = async () => {
    if (language === 'tm') {
      setMessage('Garaşyň...');
    } else if (language === 'ru') {
      setMessage('Пожалуйста подождите...');
    }
      const response = await fetch(`${apiUrl}/api/confirm-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(loginData),
      });
      const result = await response.json();
      validInputsReqLogin(result.request.status, result.request.token, result.request.asd)
      
  };

  const client_login = async () => {
    if (language === 'tm') {
      setMessage('Garaşyň...');
    } else if (language === 'ru') {
      setMessage('Пожалуйста подождите...');
    }
    try {
      // Логика для отправки данных на сервер
      const response = await fetch(`${apiUrl}/api/client-login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(loginData), // Убедитесь, что loginData правильно формируется
      });
  
      const result = await response.json();
      validInputsReqLogin(result.request.status, result.request.token, result.request.asd)
    } catch (error) {
      console.error('Ошибка при обработке запроса:', error);
      setMessage('Ошибка при обработке запроса.');
    }
  };

  const requestPasswordReset = async () => {
    setMessage(language === 'ru' ? 'Пожалуйста подождите...' : language === 'tm' ? 'Garaşyň...' : 'Please wait...');
    try {
      const response = await fetch(`${apiUrl}/api/client-forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: loginData.email }),
      });
      const result = await response.json();
      if (!response.ok || result.request.status !== 0) {
        setMessage(getPasswordResetError(result.request.status, result.request.message));
        return;
      }

      setResetCodeEnter(true);
      setMessage(
        language === 'ru'
          ? 'Если аккаунт с таким адресом зарегистрирован, код отправлен на почту.'
          : language === 'tm'
            ? 'Eger bu elektron poçta hasaba alnan bolsa, kod poçta iberildi.'
            : 'If an account exists for this email, a code has been sent.'
      );
    } catch (error) {
      console.error('Ошибка при запросе восстановления пароля:', error);
      setMessage('Ошибка при обработке запроса.');
    }
  };

  const resetPassword = async () => {
    setMessage(language === 'ru' ? 'Пожалуйста подождите...' : language === 'tm' ? 'Garaşyň...' : 'Please wait...');
    try {
      const response = await fetch(`${apiUrl}/api/client-reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: loginData.email,
          code: loginData.code,
          password: loginData.password,
          confirm_password: loginData.confirm_password,
        }),
      });
      const result = await response.json();
      if (!response.ok || result.request.status !== 0) {
        setMessage(getPasswordResetError(result.request.status, result.request.message));
        return;
      }

      setResetMode(false);
      setResetCodeEnter(false);
      setIsLogin(false);
      setLoginData((previous) => ({
        ...previous,
        code: '',
        password: '',
        confirm_password: '',
      }));
      setMessage(
        language === 'ru'
          ? 'Пароль успешно изменён. Войдите с новым паролем.'
          : language === 'tm'
            ? 'Parol üýtgedildi. Täze parol bilen giriň.'
            : 'Password changed. Sign in with your new password.'
      );
    } catch (error) {
      console.error('Ошибка при изменении пароля:', error);
      setMessage('Ошибка при обработке запроса.');
    }
  };

  const getPasswordResetError = (status, fallback) => {
    const messages = {
      ru: {
        1: 'Неверный код.',
        2: 'Срок действия кода истёк. Запросите новый код.',
        3: 'Заполните все поля.',
        4: 'Пароль должен содержать не менее 5 символов.',
        5: 'Пароли не совпадают.',
        7: 'Введите корректный адрес электронной почты.',
        8: 'Не удалось отправить письмо. Попробуйте позже.',
      },
      tm: {
        1: 'Kod nädogry.',
        2: 'Kodyň möhleti geçdi. Täze kod soraň.',
        3: 'Ähli meýdanlary dolduryň.',
        4: 'Parol azyndan 5 nyşandan ybarat bolmaly.',
        5: 'Parollar gabat gelenok.',
        7: 'Dogry elektron poçta salgysyny giriziň.',
        8: 'Hat iberilmedi. Soň täzeden synanyşyň.',
      },
      en: {
        1: 'The code is invalid.',
        2: 'The code has expired. Request a new one.',
        3: 'Complete all fields.',
        4: 'Password must contain at least 5 characters.',
        5: 'Passwords do not match.',
        7: 'Enter a valid email address.',
        8: 'Could not send the email. Please try again later.',
      },
    };

    return messages[language]?.[status] || fallback || 'Не удалось выполнить запрос.';
  };

  const openPasswordReset = () => {
    setResetMode(true);
    setResetCodeEnter(false);
    setCodeEnter(false);
    setMessage('');
    setLoginData((previous) => ({
      ...previous,
      code: '',
      password: '',
      confirm_password: '',
    }));
  };

  const cancelPasswordReset = () => {
    setResetMode(false);
    setResetCodeEnter(false);
    setMessage('');
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // if (isRegister) {
    //   setLoginData((prev) => {
    //     const updatedData = { ...prev, [name]: value };
    
    //     // Проверка на минимальную длину пароля
    //     if (name === 'password' && value.length < 5) {
    //       setMessage('Пароль должен иметь как минимум 5 символов');
    //     } else if (name === 'confirm_password' || name === 'password') {
    //       // Проверка на совпадение паролей
    //       if (updatedData.password !== updatedData.confirm_password) {
    //         setMessage('Пароли не совпадают');
    //       } else {
    //         setMessage(''); // Сброс ошибки, если всё совпадает
    //       }
    //     }
    
    //     return updatedData;
    //   });
    // } else {
      setLoginData((prev) => ({ ...prev, [name]: value }));
    // }

  };


  useEffect(() => {
      // Запрос к API для получения списка видео
      axios
        .get(`${apiUrl}/api/client/get-manual-video`)
        .then((response) => {
          setVideo(response.data);
        })
        .catch((error) => {
          console.error("Ошибка при получении видео:", error);
        });
  }, []);
  const langs = {
    'ru': {
      'title': "Регистрация",
      'title_2': "Вход",
      'email': "Электронная почта",
      'email_placeholder': "Введите действующую эл. почту",
      'phone': "Телефон",
      'phone_placeholder': "Введите ваш номер телефона",
      'password': "Пароль",
      'password_placeholder': "Придумайте пароль",
      'passwordc': "Подтвердите пароль",
      'passwordc_placeholder': "Введите пароль еще раз",
      'login_btn': "Войти",
      'register_btn': "Регистрация",
      'create_acc': "Нет аккаунта?", 
      'login_acc': "У вас уже есть аккаунт?", 
      'sendcode': "Отправить код", 
      'code': "Код из письма", 
      'forgot_password': "Забыли пароль?",
      'reset_title': "Восстановление пароля",
      'send_reset_code': "Получить код",
      'reset_password': "Изменить пароль",
      'new_password': "Новый пароль",
      'back_to_login': "Вернуться ко входу",
    },
    'tm': {
      'title': "Hasaba al",
      'title_2': "Girmek uçin",
      'email': "Elektron poçta",
      'email_placeholder': "Işjeň elektron poçtaňyzy giriziň",
      'phone': "Telefon",
      'phone_placeholder': "Telefon belgiňizi giriziň",
      'password': "Parol",
      'password_placeholder': "Parol oýlap tapyň",
      'passwordc': "Paroly tassyklanyň",
      'passwordc_placeholder': "Paroly ýene giriziň",
      'login_btn': "Girmek",
      'register_btn': "Hasaba al",
      'create_acc': "Hasabyňyz ýokmy?", 
      'login_acc': "Hasabyňyz barmy?", 
      'sendcode': "Kod ibermek", 
      'code': "Email-den gelen kod", 
      'forgot_password': "Paroly unutdyňyzmy?",
      'reset_title': "Paroly dikeltmek",
      'send_reset_code': "Kod almak",
      'reset_password': "Paroly üýtgetmek",
      'new_password': "Täze parol",
      'back_to_login': "Girişe dolanmak",
    },
    'en': {
      'title': "Registration",
      'title_2': "Sign in",
      'email': "Email",
      'email_placeholder': "Enter a valid email address",
      'phone': "Phone",
      'phone_placeholder': "Enter your phone number",
      'password': "Password",
      'password_placeholder': "Create a password",
      'passwordc': "Confirm Password",
      'passwordc_placeholder': "Enter the password again",
      'login_btn': "Login",
      'register_btn': "Register",
      'create_acc': "Don't have an account?", 
      'login_acc': "Do you have an account?", 
      'sendcode': "Send code", 
      'code': "Code from email", 
      'forgot_password': "Forgot password?",
      'reset_title': "Reset password",
      'send_reset_code': "Get code",
      'reset_password': "Change password",
      'new_password': "New password",
      'back_to_login': "Back to sign in",
    }
  };
  
  return (
    <div className="background-floor client-auth-overlay">
      <div className='block-form-login-manual client-auth-layout'>
        <form className="form-simple container client-auth-form">
          {resetMode ? (
            <>
              <h4 className='form-simple__title'>{langs[language].reset_title}</h4>
              {!resetCodeEnter ? (
                <div className="form-group">
                  <label htmlFor="reset-email">{langs[language].email}:</label>
                  <input
                    type="email"
                    placeholder={langs[language].email_placeholder}
                    value={loginData.email}
                    id="reset-email"
                    name="email"
                    required
                    onChange={handleInputChange}
                  />
                </div>
              ) : (
                <>
                  <div className="form-group">
                    <label htmlFor="reset-code">{langs[language].code}:</label>
                    <input
                      type="text"
                      value={loginData.code}
                      id="reset-code"
                      name="code"
                      required
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="reset-password">{langs[language].new_password}:</label>
                    <input
                      type="password"
                      placeholder={langs[language].password_placeholder}
                      value={loginData.password}
                      id="reset-password"
                      name="password"
                      required
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="reset-confirm-password">{langs[language].passwordc}:</label>
                    <input
                      type="password"
                      placeholder={langs[language].passwordc_placeholder}
                      value={loginData.confirm_password}
                      id="reset-confirm-password"
                      name="confirm_password"
                      required
                      onChange={handleInputChange}
                    />
                  </div>
                </>
              )}
              <h3 className='error-message'>{message && message}</h3>
              <button
                type="button"
                className="button-booking"
                onClick={resetCodeEnter ? resetPassword : requestPasswordReset}
              >
                {resetCodeEnter ? langs[language].reset_password : langs[language].send_reset_code}
              </button>
              <p className='toggleClientForm'>
                <span onClick={cancelPasswordReset}>{langs[language].back_to_login}</span>
              </p>
            </>
          ) : codeEnter === false ? (
            isRegister ? (
              <>
              <h4 className='form-simple__title'>{langs[language].title}</h4>
              {/* <!-- Электронная почта --> */}
              <div className="form-group">
                <label htmlFor="email">{langs[language].email}:</label>
                <input type="email" placeholder={langs[language].email_placeholder} value={loginData.email} id="email" name="email" required onChange={handleInputChange} />
              </div>

              <div className="form-group">
                <label htmlFor="phone">{langs[language].phone}:</label>
                <input type="tel" maxLength={12} placeholder={langs[language].phone_placeholder} value={loginData.phone} id="phone" name="phone" required onChange={handleInputChange} />
              </div>

              <div className="form-group">
                <label htmlFor="password">{langs[language].password}</label>
                <input type="password" placeholder={langs[language].password_placeholder} value={loginData.password} id="password" name="password" required onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label htmlFor="confirm_password">{langs[language].passwordc}</label>
                <input type="password" placeholder={langs[language].passwordc_placeholder} value={loginData.confirm_password} id="confirm_password" name="confirm_password" required onChange={handleInputChange} />
              </div>

              <h3 className='error-message'>{message && message}</h3>
              {/* <!-- Кнопка для подтверждения бронирования --> */}
              <button type="button" className="button-booking" onClick={() => client_register()}>
                {langs[language].register_btn}
              </button>
              <p className='toggleClientForm'>{langs[language].login_acc} <span onClick={handleToggle}>{langs[language].login_btn}</span></p>
              </>
            ) : (
              <>
              <h4 className='form-simple__title'>{langs[language].title_2}</h4>
              {/* <!-- Электронная почта --> */}
              <div className="form-group">
                <label htmlFor="email">{langs[language].email}:</label>
                <input type="email" placeholder={langs[language].email_placeholder} value={loginData.email} id="email" name="email" required onChange={handleInputChange} />
              </div>

              <div className="form-group">
                <label htmlFor="password">{langs[language].password}</label>
                <input type="password" placeholder={langs[language].password} value={loginData.password} id="password" name="password" required onChange={handleInputChange} />
              </div>

              <h3 className='error-message'>{message && message}</h3>
              {/* <!-- Кнопка для подтверждения бронирования --> */}
              <button type="button" className="button-booking" onClick={() => client_login()}>
                {langs[language].login_btn}
              </button>
              <p className='toggleClientForm'>{langs[language].create_acc} <span onClick={handleToggle}>{langs[language].register_btn}</span></p>
              <p className='toggleClientForm'><span onClick={openPasswordReset}>{langs[language].forgot_password}</span></p>
              </>
            )
          ) : (
            <>
              <div className="form-group">
                <input type="text" placeholder={langs[language].code} value={loginData.code} id="code" name="code" required onChange={handleInputChange} />
              </div>
              <button type="button" className="button-booking" onClick={() => confirm_email()}>
                {langs[language].sendcode}
              </button>
            </>
          )}

        </form>

        {video &&
          <div className="block-form-login-manual__block">
              <div className="">
                  <video controls controlsList="nodownload">
                      <source src={`${apiUrl}${video.url}`} type="video/mp4" />
                      Ваш браузер не поддерживает видео тег. Пожалуйста обновите браузер или попробуйте другой.
                  </video>
              </div>
          </div>
        }
      </div>
    </div>
  )
}

export default ClientRegisterComponent;